<template>
  <div>
    <label class="t-mb-0 t-text-gray-900">
      {{ labelText }}
    </label>

    <!-- Dropdown -->
    <div class="t-relative">
      <div
        v-show="showDropdown"
        class="t-absolute t-bottom-0 t-mt-2 t-border t-border-gray-400 t-w-full t-bg-white t-shadow-lg"
      >
        <ul class="dropdown t-rounded-md py-1 t-text-base t-overflow-auto focus:t-outline-none sm:t-text-sm">
          <li
            v-for="(timeSlot, i) in availableBusinessHours"
            :key="i"
            @click="onSelectedTimeSlotChanged(timeSlot, i)"
            class="t-cursor-default t-select-none t-relative t-py-3 t-pl-3 t-pr-9 hover:t-bg-indigo-600 hover:t-text-white"
            :class="(timeSlot === selectedTimeSlot) ? 'selected-time-slot t-bg-indigo-600 t-font-semibold t-text-white' : 't-text-gray-900'"
            role="option"
          >
            <div class="t-flex t-items-center">
              <span class="t-ml-4 t-block t-font-normal t-truncate t-text-sm">
                {{ timeSlot }}
              </span>
            </div>

            <!-- Checkmark for selected time -->
            <span v-show="timeSlot === selectedTimeSlot" class="t-absolute t-inset-y-0 t-right-0 t-flex t-items-center t-pr-4">
              <svg class="t-h-6 t-w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path
                  fill-rule="evenodd"
                  d="M15.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <!-- Dropdown Button -->
    <button
      @click="onDropdownButtonClick"
      v-click-outside="onClickOutside"
      type="button" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label"
      class="t-relative t-w-full t-bg-white t-border t-border-gray-400 t-rounded-md t-shadow-sm t-pl-3
      t-pr-10 t-py-2 t-text-left t-cursor-default t-focus:outline-none focus:t-border-indigo-500 sm:t-text-sm"
    >
      <span class="t-flex t-items-center">
        <span class="t-ml-3 t-block t-truncate">
          {{ selectedTimeSlot }}
        </span>
      </span>
      <span class="t-ml-3 t-absolute t-inset-y-0 t-right-0 t-flex t-items-center t-pr-2 t-pointer-events-none">
        <svg class="t-h-5 t-w-5 t-text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path
            fill-rule="evenodd"
            d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BusinessHoursDropdown',
  props: {
    labelText: {
      type: String
    },
    availableBusinessHours: {
      type: Array
    },
    timeSlot: {
      type: String
    }
  },
  data() {
    return {
      showDropdown: false,
      selectedTimeSlot: ''
    }
  },
  created() {
    this.selectedTimeSlot = this.timeSlot;
  },
  methods: {
    onDropdownButtonClick() {
      this.showDropdown = !this.showDropdown;

      if (this.showDropdown) {
        this.$nextTick(() => {
          let selectedTimeSlot = this.$el.getElementsByClassName('selected-time-slot')[0];
          if (selectedTimeSlot) {
            selectedTimeSlot.scrollIntoView();
          }
        });
      }
    },
    onClickOutside() {
      this.showDropdown = false;
    },
    onSelectedTimeSlotChanged(timeSlot) {
      this.selectedTimeSlot = timeSlot;
      this.$emit('selectedTimeSlotChanged', timeSlot);
    }
  }
}
</script>

<style scoped>
.dropdown {
  height: 18rem;
}
</style>